<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ validate, reset }">
      <v-card>
        <v-card-title class="pa-0">
          <v-title>Employee Profile</v-title>
        </v-card-title>
        <v-card-text>
          <v-form pa-0 ma-0 v-model="valid" lazyValidation>
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="jobTitle"
                    rules="required"
                  >
                    <v-text-field
                      label="Job Title"
                      v-model="employee.jobTitle"
                      name="jobTitle"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12 md6>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="firstName"
                    rules="required"
                  >
                    <v-text-field
                      label="First Name"
                      v-model="employee.firstName"
                      name="firstName"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12 md6>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="lastName"
                    rules="required"
                  >
                    <v-text-field
                      label="Last name"
                      v-model="employee.lastName"
                      name="lastName"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12 md6>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Email"
                    rules="required"
                  >
                    <v-text-field
                      label="Email"
                      v-model="employee.email"
                      name="Email"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12 md6>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="contactNumber"
                    rules="required|phonenumber"
                  >
                    <v-text-field
                      label="Phone Number"
                      v-model="employee.contactNumber"
                      name="contactNumber"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12 md6>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="authorityLevel"
                    rules="required"
                  >
                    <v-select
                      :items="['Admin', 'Employee']"
                      v-model="employee.authorityLevel"
                      label="Authority Level"
                      name="authorityLevel"
                      :error-messages="errors"
                    ></v-select>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12 md6>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="headDealer"
                    rules="required"
                  >
                    <v-autocomplete
                      label="Assign to UB Dealer"
                      v-model="new_headAgent"
                      name="headDealer"
                      :items="filterDealers"
                      search-input.sync="model"
                      item-text="ubDealerID"
                      item-value="ubDealerID"
                      auto-select-first
                      clearable
                      :disabled="isUpdating"
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="isUpdating" color="secondary" @click="confirmDelete">
            Delete
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save" :disabled="!formValid">
            Save
          </v-btn>
          <v-btn color="light-grey" @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapEmployeeActions } = createNamespacedHelpers(
  `orders/employee`
);
import { Employee } from '../../../models/Employee';

export default {
  name: 'EmployeeDetail',
  props: {
    employeeDetails: {
      type: Object,
      required: true,
    },
    head: {
      type: Number,
      required: true,
    },
    isUpdating: {
      type: Boolean,
    },
  },
  data() {
    return {
      valid: true,
      formValid: true,
      employee: {},
      new_headAgent: null,
      allDealers: [],
      toFilter: [],
      items: ['Admin', 'Employee'],
      hasDuplicateEmail: false,
    };
  },
  computed: {
    filterDealers() {
      let vm = this;
      if (vm.new_headAgent == null)
        return vm.allDealers.filter(x => x.ubDealerID !== 0);
      return vm.allDealers.filter(x =>
        x.ubDealerID.toString().includes(vm.new_headAgent.toString())
      );
    },
  },
  watch: {
    new_headAgent(val) {
      let vm = this;
      if (val != undefined)
        vm.toFilter = vm.allDealers.filter(x =>
          x.ubDealerID.toString().includes(val.toString())
        );
      vm.checkFormValidity();
    },
    employee: {
      deep: true,
      handler() {
        this.checkFormValidity();
      },
    },
  },
  methods: {
    ...mapEmployeeActions(['addEmployee', 'getUBDealers', 'deleteEmployee']),
    checkFormValidity() {
      let vm = this;
      const {
        jobTitle,
        firstName,
        lastName,
        email,
        contactNumber,
        authorityLevel,
      } = vm.employee;

      if (
        !jobTitle ||
        !firstName ||
        !lastName ||
        !email ||
        !contactNumber ||
        !authorityLevel ||
        !vm.new_headAgent
      ) {
        vm.formValid = false;
      } else {
        vm.formValid = true;
      }
    },
    close() {
      this.$emit('close');
    },
    save() {
      let vm = this;
      vm.$refs.observer.validate().then(result => {
        let newHead = vm.allDealers.filter(
          x => x.ubDealerID == vm.new_headAgent
        )[0].dealerID;
        vm.addEmployee({
          employee: new Employee(vm.employee),
          isUpdating: vm.isUpdating,
          headDealer: vm.head,
          newHeadDealer: newHead,
        }).then(data => {
          if (data.success) {
            vm.$emit('saved');
          }

          if (vm.isUpdating) vm.$refs.observer.reset();
        });
      });
    },
    confirmDelete() {
      let vm = this;
      vm.$dialog
        .confirm('You are about to delete employee, are you sure?')
        .then(() => {
          vm.deleteEmployee(vm.employee)
            .then(data => {
              vm.$emit('close');
            })
            .catch(() => {})
            .finally(() => {
              vm.$emit('close');
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    let vm = this;
    vm.employee = vm.employeeDetails;
    vm.new_headAgent = vm.head == 0 ? null : vm.head;

    vm.getUBDealers().then(data => {
      vm.allDealers = data;
    });
    vm.checkFormValidity();
  },
};
</script>

<style scoped></style>
